import React from "react";
import TabbedPage from "../../Elements/TabbedPage";
import Reporting from "./Reporting/Reporting";
import ServiceList from "./Service/ServiceList";

export default class PlanningMain extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  tabs = [
    { label: "Planning", id: "importshops", icon: "fa-solid fa-shipping-fast", component: <ServiceList /> },
    { label: "Reporting", id: "sftpservers", icon: "fa-solid fa-server", component: <Reporting /> },
  ];

  render() {
    return (
      <div className="TabbedPage">
        <TabbedPage
          tabs={this.tabs}
          className="border rounded opacity70"
        />
      </div>
    );
  }
}
